import { render } from "./PaginationNew.vue?vue&type=template&id=8658e4a8&ts=true"
import script from "./PaginationNew.vue?vue&type=script&lang=ts"
export * from "./PaginationNew.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__